import { render, staticRenderFns } from "./ScopeOfWorksSection.vue?vue&type=template&id=5ac217c9&"
import script from "./ScopeOfWorksSection.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWorksSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports